"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAudioVideoObserver = createAudioVideoObserver;
var _logger = require("@studio/logger");
var _constants = require("../../constants");
var _MetricsDidReceive = require("../../metrics/MetricsDidReceive");
var _ = require("../..");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function createAudioVideoObserver(dispatch, actions, meetingSession, meetingResponse, attendeeResponse) {
  var hasLocalTile = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var currentAttendeeId = attendeeResponse.Attendee.AttendeeId;
  function sendChimeConnectionLogs(event) {
    var title = "".concat(event, " - attendeeId: ").concat(currentAttendeeId);
    (0, _logger.sendToDatadog)(_constants.loggerName, _objectSpread(_objectSpread({}, networkPayload), {}, {
      title: title,
      'attendee-id': currentAttendeeId,
      chimeEventName: event
    }));
  }
  var videoTileDidUpdateHandler = actions.videoTileDidUpdateHandler,
    videoTileWasRemovedHandler = actions.videoTileWasRemovedHandler,
    networkPayload = actions.networkPayload,
    setAttendeeNetworkHealth = actions.setAttendeeNetworkHealth,
    setAttendeeReceivedFrame = actions.setAttendeeReceivedFrame,
    remoteVideoSourcesDidChangeHandler = actions.remoteVideoSourcesDidChangeHandler;
  var audioVideoObserver = {
    audioVideoDidStart: function audioVideoDidStart() {
      (0, _.audioVideoDidStartHandler)(meetingSession, meetingResponse, attendeeResponse, hasLocalTile);
    },
    audioVideoDidStartConnecting: function audioVideoDidStartConnecting(reconnecting) {
      (0, _.audioVideoDidStartConnectingHandler)(reconnecting, meetingResponse, attendeeResponse);
    },
    // Use case 28 https://github.com/aws/amazon-chime-sdk-js
    audioVideoDidStop: function audioVideoDidStop(sessionStatus) {
      (0, _.audioVideoDidStopHandler)(sessionStatus, meetingSession, meetingResponse, attendeeResponse, hasLocalTile);
    },
    connectionDidBecomeGood: function connectionDidBecomeGood() {
      sendChimeConnectionLogs('connectionDidBecomeGood');
    },
    connectionDidBecomePoor: function connectionDidBecomePoor() {
      sendChimeConnectionLogs('connectionDidBecomePoor');
    },
    connectionDidSuggestStopVideo: function connectionDidSuggestStopVideo() {
      sendChimeConnectionLogs('connectionDidSuggestStopVideo');
    },
    connectionHealthDidChange: function connectionHealthDidChange(connectionHealthData) {
      networkPayload.connectionHealthData = connectionHealthData;
    },
    metricsDidReceive: function metricsDidReceive(clientMetricReport) {
      (0, _MetricsDidReceive.metricsDidReceiveHandler)(dispatch, setAttendeeNetworkHealth, setAttendeeReceivedFrame, meetingSession, currentAttendeeId, networkPayload, clientMetricReport);
    },
    remoteVideoSourcesDidChange: function remoteVideoSourcesDidChange(videoSources) {
      remoteVideoSourcesDidChangeHandler(videoSources, meetingSession, meetingResponse);
    },
    videoTileWasRemoved: function videoTileWasRemoved(tileId) {
      videoTileWasRemovedHandler(tileId);
    },
    videoTileDidUpdate: function videoTileDidUpdate(tileState) {
      videoTileDidUpdateHandler(tileState);
    }
  };
  return audioVideoObserver;
}